import { configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import { dashboardApi } from "../service/dashboardApi";
import { settingsApi } from '../service/settingsApi';
import { promptApi } from "../service/promptApi";
import { mockupApi } from "../service/mockupApi";
import { integrationApi } from "@service/integrationApi";
import { authApi } from "@service/authApi";
import { subscriptionApi } from "@service/subscriptionApi";

import dashboardReducer from "./slices/dashboardSlice";
import mockupLabReducer from "./slices/mockupLabSlice";
import errorReducer from "./slices/errorSlice";
import integrationReducer from "./slices/integrationSlice";
import subscriptionReducer from "./slices/subscriptionSlice";
import portalLabReducer from "./slices/portalLabSlice";

import { rtkQueryErrorLogger } from "./middleware/rtkQueryErrorMiddleware";

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const store = configureStore({
    reducer: {
        dashboard: dashboardReducer,
        mockupLab: mockupLabReducer,
        error: errorReducer,
        integration: integrationReducer,
        subscription: subscriptionReducer,
        portalLab: portalLabReducer,

        [dashboardApi.reducerPath]: dashboardApi.reducer,
        [settingsApi.reducerPath]: settingsApi.reducer,
        [promptApi.reducerPath]: promptApi.reducer,
        [mockupApi.reducerPath]: mockupApi.reducer,
        [integrationApi.reducerPath]: integrationApi.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(dashboardApi.middleware)
            .concat(settingsApi.middleware)
            .concat(promptApi.middleware)
            .concat(mockupApi.middleware)
            .concat(integrationApi.middleware)
            .concat(authApi.middleware)
            .concat(subscriptionApi.middleware)
            .concat(rtkQueryErrorLogger),
    enhancers: (getDefaultEnhancers) =>
        getDefaultEnhancers().concat(sentryReduxEnhancer)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;